var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluctuations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 18V4H4.75V18C4.75 18.1381 4.86193 18.25 5 18.25H20V19.75H5C4.0335 19.75 3.25 18.9665 3.25 18Z",
    fill: "#B3C2D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 16.293L7.34421 13.4826L11.0603 15.9987L14.2957 12.175L14.2973 12.1764L17 8.99998L17.201 11.386L18.6952 11.2532L18.2533 6.28015L13.2802 6.72204L13.413 8.21615L15.8354 8.0009L13.4006 10.9107L10.7855 14.0011L7.117 11.5172L4.75 14.0815V16.293Z",
    fill: "#B3C2D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluctuations);
export default __webpack_public_path__ + "static/media/fluctuations.8ca9716fd97cb4161bbcf5b8294b979b.svg";
export { ForwardRef as ReactComponent };